import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zur Anzeige des Lizenz-Import-Ergebnisses (Erfolg/Warnung/Fehler).
 */
function LicenseImportResultDialog({ open, onClose, result }) {
  const { t } = useTranslation();
  if (!open || !result) return null;

  const type = result.type;
  const title = type === 'success' ? `✅ ${t('dialog.license_import.success')}` :
    type === 'warning' ? `⚠️ ${t('dialog.license_import.warning')}` : `❌ ${t('dialog.license_import.error')}`;

  const details = result.details;
  const messageClass =
    type === 'success'
      ? 'license-import-message license-import-message--success'
      : type === 'warning'
        ? 'license-import-message license-import-message--warning'
        : 'license-import-message license-import-message--error';

  return (
    <div className="edit-overlay" onClick={onClose}>
      <div
        className="edit-modal license-import-result-dialog"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '550px' }}
      >
        <div className="edit-header">
          <h3>{title}</h3>
          <button type="button" className="btn-close" onClick={onClose}>×</button>
        </div>
        <div className="edit-content">
          <p
            className={messageClass}
            style={{ marginBottom: details ? '20px' : '0' }}
          >
            {result.message}
          </p>
          {details && (
            <div className="license-import-details">
              {details.license_key && (
                <div className="license-import-key-block">
                  <strong className="license-key-label">{t('dialog.license_import.key')}</strong>
                  <code className="license-key-code license-import-key-code">{details.license_key}</code>
                </div>
              )}
              <div className="license-import-details-grid">
                {details.product_code && (
                  <div>
                    <strong className="license-detail-label">{t('dialog.license_import.product_code')}</strong>
                    <span className="license-detail-value">{details.product_code}</span>
                  </div>
                )}
                {details.license_type && (
                  <div>
                    <strong className="license-detail-label">{t('dialog.license_import.type')}</strong>
                    <span className="license-detail-value">{details.license_type}</span>
                  </div>
                )}
              </div>
              {(details.expires_at || (details.expires_at === null && type === 'success')) && (
                <div className="license-import-detail-row">
                  <strong className="license-detail-label">{t('dialog.license_import.expires')}</strong>
                  <span className="license-detail-value">
                    {details.expires_at
                      ? new Date(details.expires_at).toLocaleDateString('de-DE', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })
                      : t('dialog.license_import.unlimited')}
                  </span>
                </div>
              )}
              {details.is_active !== undefined && (
                <div className="license-import-detail-row">
                  <strong className="license-detail-label">{t('dialog.license_import.status')}</strong>
                  <span
                    className={
                      details.is_active
                        ? 'license-status-badge license-active'
                        : 'license-status-badge license-inactive'
                    }
                  >
                    {details.is_active ? `✅ ${t('dialog.license_import.active')}` : `❌ ${t('dialog.license_import.inactive')}`}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="edit-actions">
          <button className="btn btn-primary" onClick={onClose}>
            {t('dialog.ok')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LicenseImportResultDialog;
